import React, { useReducer, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AddCreate from "../../components/AddCreate/AddCreate";
import UseWritePost from "../../hooks/UseWritePost";
import { AddInsertreducer } from "../../interface/ActionReducer";
import { AddState } from "../../interface/initialState";
import { AddInter } from "../../interface/interface";

type LocationType = {
  state: AddInter;
};

const AddFix = () => {
  const { state: initial } = useLocation() as LocationType;
  const [state, dispatch] = useReducer(AddInsertreducer, AddState);
  const [WritePost] = UseWritePost("광고가 등록되었습니다");
  const UpadteInfo = useCallback(
    (type: string, payload: string | number) => {
      dispatch({
        type,
        payload,
        index: undefined,
      });
    },
    [dispatch]
  );
  const FixAdd = useCallback(() => {
    const {
      ctts_tit,
      ctts_ctts,
      bg_color,
      ctts_link,
      ad_thumbnail,
      ctts_id,
      btn_label,
    } = state;
    if (
      ctts_tit &&
      btn_label &&
      ctts_ctts &&
      bg_color &&
      ctts_link &&
      ad_thumbnail &&
      ctts_id
    ) {
      WritePost(
        {
          ctts_id,
          bbs_id: "5",
          ctts_tit,
          btn_label,
          ctts_ctts,
          ctts_ctg_cd: "normal",
          bg_color,
          ctts_link,
          ad_thumbnail,
        },
        true
      );
    }
  }, [state, WritePost]);

  useEffect(() => {
    const {
      ctts_id,
      ctts_tit,
      ctts_link,
      ad_thumbnail,
      btn_label,
      ctts_ctg_cd,
      bg_color,
      ctts_ctts,
    } = initial;
    dispatch({
      type: "add/all",
      payload: {
        ctts_id,
        bg_color: bg_color,
        ctts_ctts,
        ad_thumbnail,
        ctts_link,
        ctts_tit,
        btn_label: btn_label,
        ctts_ctg_cd,
      },
      index: undefined,
    });

    return () => {};
  }, [initial]);

  return (
    <AddCreate
      data={state}
      UpdateInfo={UpadteInfo}
      WritePost={FixAdd}
      addType="fix"
    />
  );
};

export default AddFix;
